const RESET_PASSWORD_ROUTE = '/reset-password';
const SYSTEM_OVERVIEW_ROUTE = '/system-overview';

// profile
const PROFILE_ROUTE = '/profile';
const PROFILE_DETAILS_ROUTE = 'details';

// dashboard
const DASHBOARD_ROUTE = '/';
const DASHBOARD_HISTORY_ROUTE = `${DASHBOARD_ROUTE}history`;

// login
const LOGIN_ROUTE = '/login';
const LOGIN_EMAIL_ROUTE = '/login-email';
const LOGIN_PHONE_ROUTE = '/login-phone';
const LOGIN_HELP_ROUTE = '/login-help';
const LOGIN_TOS_ROUTE = '/terms-of-service';

// documents
const DOCUMENT_LIST_ROUTE = '/documents';
const CUSTOMER_AGREEMENT_ROUTE = 'customer-agreement';

// preferences pages
const SYSTEM_STATUS_ROUTE = 'system-status';
const REFERRALS_ROUTE = '/referrals';
const TERMS_OF_SERVICE_ROUTE = 'terms-of-service';

// billing
const BILLING_ROUTE = '/billing/';
const AUTOPAY_ROUTE = 'autopay';
const PAYMENT_OPTIONS_ROUTE = 'payment-options';
const VIEW_BILL_ROUTE = 'view-bill';
const SPECIAL_INVOICE_PAYMENT_ROUTE = 'pay-misc';

// payments
const ONE_TIME_BILLING_ROUTE = 'make-payment';
const MANAGE_PAYMENTS_ROUTE = 'manage-payments';
const BILLING_HISTORY_ROUTE = 'billing-history';
const AUTOPAY_INFO_ROUTE = 'autopay-information';
const AUTOPAY_ENROLL_ROUTE = 'autopay-enroll';
const AUTOPAY_UNENROLL_ROUTE = 'autopay-unenroll';
const AUTOPAY_CONFIRMATION_ROUTE = 'autopay-confirmation';
const PAYMENT_CONFIRMATION_ROUTE = 'payment-confirmation';

// support
const SUPPORT_ROUTE = '/support';
const STAR_RATING_ROUTE = `${SUPPORT_ROUTE}/rating`;

// feedback
const FEEDBACK_ROUTE = '/feedback';

// solar guide's and FAQs
const SOLAR_GUIDE_ROUTE = '/solar-guide';
const FAQ_ROUTE = '/faq';
const LG_BATTERY_ISSUE_ROUTE = '/lg-battery-safety';

// cases
const CASES_ROUTE = '/cases';

// battery retro fit project
const BATTERY_RETRO_INTEREST = '/add-battery';
const BRIGHTBOX_RETRO_INTEREST = '/add-brightbox';

// meter replacement
const METER_REPLACEMENT_INFO_ROUTE = '/meter-replacement-information';
const RTU_METER_REPLACEMENT_INFO_ROUTE = '/rtu-meter-replacement-information';

// mobile app deep linking
const CUSTOMER_APP = '/customer-app';

export {
  AUTOPAY_CONFIRMATION_ROUTE,
  AUTOPAY_ENROLL_ROUTE,
  AUTOPAY_INFO_ROUTE,
  AUTOPAY_ROUTE,
  AUTOPAY_UNENROLL_ROUTE,
  BATTERY_RETRO_INTEREST,
  BILLING_HISTORY_ROUTE,
  BILLING_ROUTE,
  BRIGHTBOX_RETRO_INTEREST,
  CASES_ROUTE,
  CUSTOMER_APP,
  SPECIAL_INVOICE_PAYMENT_ROUTE,
  CUSTOMER_AGREEMENT_ROUTE,
  DASHBOARD_HISTORY_ROUTE,
  DASHBOARD_ROUTE,
  DOCUMENT_LIST_ROUTE,
  FAQ_ROUTE,
  FEEDBACK_ROUTE,
  LG_BATTERY_ISSUE_ROUTE,
  LOGIN_EMAIL_ROUTE,
  LOGIN_HELP_ROUTE,
  LOGIN_PHONE_ROUTE,
  LOGIN_ROUTE,
  LOGIN_TOS_ROUTE,
  MANAGE_PAYMENTS_ROUTE,
  ONE_TIME_BILLING_ROUTE,
  PAYMENT_CONFIRMATION_ROUTE,
  PAYMENT_OPTIONS_ROUTE,
  PROFILE_DETAILS_ROUTE,
  PROFILE_ROUTE,
  REFERRALS_ROUTE,
  RESET_PASSWORD_ROUTE,
  SOLAR_GUIDE_ROUTE,
  STAR_RATING_ROUTE,
  SUPPORT_ROUTE,
  SYSTEM_OVERVIEW_ROUTE,
  SYSTEM_STATUS_ROUTE,
  TERMS_OF_SERVICE_ROUTE,
  VIEW_BILL_ROUTE,
  METER_REPLACEMENT_INFO_ROUTE,
  RTU_METER_REPLACEMENT_INFO_ROUTE,
};
